module.exports = __webpack_public_path__ + "assets/images/project/kranji-marshes/03.jpg?v=59783a96";